import { Link } from "react-router-dom";
import { Mail, MessageSquare, ArrowRight } from "lucide-react";

export const ContactBlock = () => (
  <section data-testid="contact-block" className="rounded-[2rem] border border-[#4A7c59]/15 bg-[#4A7c59]/5 p-8 sm:p-12">
    <div className="flex flex-col gap-6 lg:flex-row lg:items-center lg:justify-between">
      <div className="max-w-xl">
        <div className="mb-3 flex h-12 w-12 items-center justify-center rounded-full bg-white text-[#4A7c59]"><MessageSquare strokeWidth={1.8} className="h-6 w-6" /></div>
        <h2 className="font-head text-2xl font-bold text-[#2C363F] sm:text-3xl">Get in touch</h2>
        <p className="mt-2 text-muted-foreground">Questions, feedback, or want to suggest a recovery centre? We'd love to hear from you.</p>
      </div>
      <div className="flex flex-wrap gap-3">
        <Link to="/contact" data-testid="contact-block-cta" className="flex items-center gap-2 rounded-full bg-[#4A7c59] px-6 py-3.5 font-semibold text-white shadow-lg shadow-[#4A7c59]/20 transition-transform duration-300 hover:-translate-y-1">Contact us <ArrowRight className="h-4 w-4" /></Link>
        <a href="mailto:support@taperpath.co.uk" data-testid="contact-block-email" className="flex items-center gap-2 rounded-full border border-[#4A7c59]/30 bg-white px-6 py-3.5 font-semibold text-[#4A7c59] transition-transform duration-300 hover:-translate-y-1"><Mail className="h-4 w-4" /> support@taperpath.co.uk</a>
      </div>
    </div>
  </section>
);
